import { RegisterTranslate } from './registerTranslate.model';

const registerTranslatePTBR: RegisterTranslate = {
  title: {
    new: {
      lead: 'Novo cliente',
      event: 'Novo evento',
    },
    editing: {
      lead: 'Editando cliente',
      event: 'Editando evento',
    },
  },
  fields: {
    name: 'Nome',
    email: 'E-mail',
    password: 'Senha',
    passwordConfirmation: 'Confirme a senha',
    role: 'Função',
    phone: 'Celular',
    instagram: 'Instagram',
    notes: 'Observação',
    lead: 'Cliente',
    leadNone: 'Nenhum cliente',
    leadSearchPlaceholder: 'Buscar cliente',
    leadNoResults: 'Nenhum cliente encontrado',
    description: 'Descrição',
    date: 'Data',
    time: 'Hora',
    location: 'Localização',
    status: 'Situação',
    source: 'Origem',
    sourceNone: 'Sem origem',
    referrer: 'Indicado por',
    checklist: 'Aplicar checklist',
    checklistNone: 'Sem checklist',
    badges: 'Etiquetas',
  },
  errors: {
    name: {
      required: 'Nome é obrigatório',
      invalid: 'O nome deve conter apenas letras e espaços.',
    },
    email: {
      required: 'E-mail é obrigatório',
      invalid: 'Formato de e-mail inválido',
    },
    password: {
      required: 'Senha é obrigatória',
      invalid: 'Senha deve conter no mínimo 8 caracteres',
    },
    passwordConfirmation: {
      invalid: 'As senhas devem ser iguais',
    },
    role: {
      required: 'Função é obrigatória',
    },
    phone: {
      invalid: 'Celular deve conter no máximo 30 caracteres',
    },
    instagram: {
      invalid: 'Instagram deve conter no máximo 30 caracteres',
      invalidUserName: 'Nome de usuário do Instagram inválido',
    },
    notes: {
      invalid: 'Observações deve conter no máximo 300 caracteres',
    },
    location: {
      invalid: 'A localização deve conter no máximo 100 caracteres',
    },
    description: {
      required: 'Descrição é obrigatória',
      invalid: 'Descrição deve conter no máximo 100 caracteres',
    },
    date: {
      invalid: 'Data deve estar no formato dd/MM/yyyy',
    },
  },
  submit: 'Salvar',
  clearFields: 'Limpar',
  timePicker: {
    apply: 'Aplicar',
    cancel: 'Cancelar',
    triggerLabel: 'Selecionar horário',
  },
  toast: {
    lead: {
      created: 'Cliente adicionado com sucesso',
      updated: 'Cliente atualizado com sucesso',
      error: 'Erro ao criar cliente',
      partialBadges:
        'Cliente salvo, mas {{count}} etiqueta(s) não puderam ser aplicadas. Revise antes de fechar.',
    },
    event: {
      created: 'Evento adicionado com sucesso',
      updated: 'Evento atualizado com sucesso',
      error: 'Erro ao criar evento',
    },
  },
  select: {
    eventStatus: {
      SCHEDULED: 'Agendado',
      COMPLETED: 'Concluído',
      CANCELED: 'Cancelado',
      EDITING: 'Editando',
      DELIVERED: 'Entregue',
      ARCHIVED: 'Arquivado',
    },
  },
};

export default registerTranslatePTBR;
